import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=10394fe2&scoped=true"
import script from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=10394fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10394fe2",
  null
  
)

export default component.exports